import { useResolvedActions } from '@common/hooks/useResolvedActions';
import { ActionItem, ActionsProps } from '@common/types/actions';
import { ActionButton } from './ActionButton';
import { ButtonProps } from '@radix-ui/themes';

type BulkActionsProps<T extends ActionItem> = ActionsProps<T> & ButtonProps;

export const BulkActions = <T extends ActionItem>({
    actions,
    selectedItems,
    ...props
}: BulkActionsProps<T>) => {
    const resolvedActions = useResolvedActions({ actions, selectedItems });

    return (
        <>
            {resolvedActions.map((action, index) => (
                <ActionButton
                    key={`${index}-${action.label}`}
                    highContrast
                    size={'2'}
                    {...props}
                    color={action.color}
                    onClick={action.onClick}
                >
                    {action.icon}
                    {action.label}
                </ActionButton>
            ))}
        </>
    );
};
